@import "../../styles/colors";

.root {
  position: relative;
  display: flex;
  flex-flow: column wrap;
  align-items: space-around;
  justify-content: center;
  align-items: center;
  padding-top: 60vh;
  z-index: 1;
}

.container {
  position: relative;
  width: 30em;
  margin-top: -150vh;
  margin-left: 20px;
}

.circleRings {
  position: absolute;
  top: -50;
  left: 0;
  right: 0;
}

.circleRingsColor {
  position: absolute;
  top: 280;
  left: 0;
  right: 0;
  margin-right: 60px;
  margin-top: 380px;
}

#blackBg {
  z-index: -1;
}



.gradient {
  z-index: 1;
}

.circleInner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 3px solid $plum;
  border-radius: 50%;
}

.outerCircle {
  position: absolute;
  height: 300px;
  width: 300px;
  background: linear-gradient(#14ffe9, #ffeb3b, #ff00e0);
  border-radius: 50%;
  animation: rotate 15s linear infinite;
  top: 2px;
}

@keyframes rotate {
  0% {
    filter: hue-rotate(0deg);
  }
  100% {
    filter: hue-rotate(360deg);
  }
}